import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { connect } from 'react-redux';
import Spinner from '../Widgets/spinner';
import ContentWrapper from '../Layout/ContentWrapper';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';


class PurchaseHistoryGrid extends Component {
  constructor() {
    super();
    this.state = {
      purchaseHistory: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.purchaseItemHistory && nextProps.purchaseItemHistory !== this.props.purchaseItemHistory) {
      let name = '';
      if (nextProps.purchaseItemHistory[0]) {
        name = nextProps.purchaseItemHistory[0].Name;
      }
      const historyRows = [...nextProps.purchaseItemHistory];
      historyRows.map(row => {
        row.Date = String(row.Date).substring(0, 10);
      });
      const purchaseHistory = { ...this.state.purchaseHistory, rows: historyRows };
      this.setState({ purchaseHistory, productHistoryLabel: name });
    }
  }

  render() {
      const getRows = () => {
        return Data.Selectors.getRows(this.state.purchaseHistory);
      };

      const getSize = () => {
        return getRows().length;
      };

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var purchaseHistory = { ...this.state.purchaseHistory, sortColumn: sortColumn, sortDirection: sortDirection };
        this.setState({ purchaseHistory });
      }

      return (
        <Row>
          <Col xs={12}>
            <div className="react-table-customizer" id="PurchaseHistoryGrid-dataGrid1">
              <ReactDataGrid
                onGridSort={handleGridSort}
                columns={this.props.columns}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect={this.props.enableRowSelect}
                minHeight={this.props.minHeight}
                onRowUpdated={this.props.handleRowUpdated}
                onRowClick={this.props.onRowClick}
                rowSelection={this.props.rowSelection}
              />
            </div>
          </Col>
        </Row>
      );
    // }
  }
}

function mapStateToProps(state) {
  return {
    purchaseItemHistory: state.salesOrders.purchaseItemHistory,
  };
}

export default connect(mapStateToProps, {})(PurchaseHistoryGrid);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/purchaseHistoryGrid.jsx